export { ReactComponent as IcoBetRecordChevron } from './IcoBetRecordChevron.svg';